import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import PropTypes from 'prop-types'
import { Collection, ForEachModel, useValue } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import DaySummary from 'widgets/smartviews/partials/DaySummary'
import WhenModelValue from 'support/conditionals/WhenModelValue'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import ScheduleSmartViewTabs from 'widgets/smartviews/shifts/ScheduleSmartViewTabs'
import { observer } from 'mobx-react'
import useActiveScheduleWeekday from 'support/hooks/use-active-schedule-weekday'
import WeekDaySelector from 'widgets/controls/WeekDaySelector'
import { Translator } from '@morningtrain/react-translations'

function ScheduleDaySummarySmartview (props) {
  const scheduleId = useValue('id')

  const [activeScheduleWeekday, setActiveScheduleWeekday] = useActiveScheduleWeekday()

  return (
    <Translator namespace='smartviews.schedule_day_summary'>
      <Smartview>
        <ScheduleSmartViewTabs active='day_summary' />
        <Collection resourceName='shifts.schedule' operationName='day_summary'>
          <Filters.StaticFilter name='schedule' value={scheduleId} />

          <WeekDaySelector onSelect={(weekDay) => setActiveScheduleWeekday(weekDay)} activeWeekday={activeScheduleWeekday} />

          <SmartviewContentSeparator />
          <ForEachModel>
            <WhenModelValue name='weekDay' condition={activeScheduleWeekday}>
              <DaySummary weekDay={activeScheduleWeekday} scheduleId={scheduleId} />
            </WhenModelValue>
          </ForEachModel>
        </Collection>
      </Smartview>
    </Translator>
  )
}

ScheduleDaySummarySmartview.defaultProps = {
  weekDay: null
}

ScheduleDaySummarySmartview.propTypes = {
  weekDay: PropTypes.number
}

export default observer(ScheduleDaySummarySmartview)
